import { useQuery } from '@tanstack/react-query';
import bootstrapData, { BootstrapData } from '../utils/bootstrapData';
import HttpResponseError from '../utils/HttpResponseError';

/**
 * Queries and returns the bootstrap data, or undefined if not yet loaded.
 * NOTE: Also consider the alternative `useSuspenseBootstrapData`
 */
export default function useBootstrapData(): BootstrapData | undefined {
  // NOTE: Query needs to match the one in `useSuspenseBootstrapData`
  const query = useQuery({
    queryKey: ['bootstrapData'],
    queryFn: bootstrapData,
    throwOnError(error) {
      return error instanceof HttpResponseError && error.response.status === 401;
    },
  });
  return query.data;
}
